module.exports = __webpack_public_path__ + "static/img/pay3.5077a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/pay3.png
// module id = CRAC
// module chunks = 1